import { TeamImportedRanking } from 'models/ranking/importedRanking/TeamImportedRanking';

export class TeamImportedRankingService {
	toModel(ranking) {
		return new TeamImportedRanking(ranking);
	}
}
